// extracted by mini-css-extract-plugin
export default {"caret":"caret__W9tVn"};